<header class="Header-Mobile">
  <h1>
    {{ titulo }}
    <img [src]="icone" />
  </h1>
</header>